module.exports = __webpack_public_path__ + "s12.no1.73173e20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/s12.no1.jpg
// module id = Z4Te
// module chunks = 0